<template>
  <div>
    <!-- media geometrica -->
    <v-divider class="mt-6 mb-4" />
    <v-subheader>
      <strong>Média geométrica</strong>
    </v-subheader>
    <app-report-table v-if="relatorio.length">
      <thead>
        <tr>
          <th class="text-center">
            Gordura
          </th>
          <th class="text-center">
            CCS
          </th>
          <th class="text-center">
            CPP
          </th>
          <th class="text-center">
            Volume
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          class="d-print-table-row"
        >
          <td
            class="text-center"
            v-text="$options.filters.decimal(geometrica('laudo_gordura'))"
          />
          <td
            class="text-center"
            v-text="$options.filters.decimal(geometrica('laudo_ccs'))"
          />
          <td
            class="text-center"
            v-text="$options.filters.decimal(geometrica('laudo_cpp'))"
          />
          <td
            class="text-center"
            v-text="$options.filters.decimal(geometrica('laudo_producao'))"
          />
        </tr>
      </tbody>
    </app-report-table>
    <div
      v-else
      class="d-flex flex-row justify-center"
    >
      <span>Não há dados suficientes para gerar uma média geométrica (mínimo de 1 laudo registrado).</span>
    </div>
  </div>
</template>
<script>
import AppReportTable from '@/components/AppReportTable'
import { mapGetters } from 'vuex'
export default {
  components: {
    AppReportTable
  },
  computed: {
    ...mapGetters(['relatorio', 'tableDense'])
  },
  methods: {
    geometrica (atributo) {
      const filtro = this.relatorio.filter(item => item[atributo] > 0)
      if (filtro.length < 2) {
        return 0
      }
      if (filtro.length === 2) {
        return this.calc(filtro.slice(-2), atributo)
      }
      return this.calc(filtro.slice(-3), atributo)
    },
    calc (array, atributo) {
      const value = array.reduce((total, valor) => (total === 0) ? valor[atributo] + total : valor[atributo] * total, 0)
      return Math.pow(value, 1 / array.length)
    }
  }
}
</script>
